import styled from 'styled-components';

import { HOME } from '../../../../theme/tokens';
import { Text } from '../../../../components';

export const Root = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
`;

export const Label = styled(Text)`
  font-size: 16px;
  font-weight: 400;
  color: ${HOME.t300};
`;

export const Value = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: ${HOME.t50};
  margin-top: 6px;
  line-height: 1.1;
`;
